import React from 'react';
import { loginSSO } from '../../containers/actions';
import PropTypes from 'prop-types';
/*
after requesting backend to get the information of sso auth, user will be redirected here and the "state", "code", "username" is passed in url
then user should try login with these credentials
*/
export default class SSOCallback extends React.Component {
  static contextTypes = {
    store: PropTypes.object, 
  }
  state = {
    loading: true,
    error: null
  };
  

  componentDidMount() {
    this.processSSOResponse();
  }

  getQueryParams() {
    const result = {
      state : this.props.location.search.match(/state=([^&]*)/)[1],
      code: this.props.location.search.match(/code=([^&]*)/)[1],
      userName: this.props.location.search.match(/userName=([^&]*)/)[1],
    };
    // this.props.location.search.push(null);
    return result;
  }

  processSSOResponse = async () => {
    try {
      // Get query parameters from URL
      const { state, code, userName} = this.getQueryParams();
      if (!state || !code || !userName) {
        this.setState({ loading: false, error: 'Missing parameters in callback URL' });
        return;
      }
      try {
        await this.context.store.dispatch(loginSSO(
          state, code, userName
      ));    
      } catch (error) {
        this.setState({
          loading: false,
          error: error.message || 'Failed to complete SSO login'
        });
      }
    } catch (error) {
      console.error('Error processing SSO response:', error);
      this.setState({
        loading: false,
        error: error.message || 'Invalid SSO response'
      });
    }
    finally{
      this.props.router.push('/')
    }
  }
  render() {
    return (
      // <div className="sso-callback">
      //   {loading && <p>Processing SSO login...</p>}
      //   {error && (
      //     <div className="error-message">
      //       <p>Error during SSO login:</p>
      //       <p>{error}</p>
      //       <button onClick={() => window.location.href = '/login'}>Back to Login</button>
      //     </div>
      //   )}
      // </div>
      <div>
        
      </div>
    );
  }
}
